export const REPORT_REFRESH_MAP = "REPORT_REFRESH_MAP";
export const SET_REPORT_DATA = "SET_REPORT_DATA";
